import { Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import styles from './DecisionLoading.module.css';

export const DecisionLoading = () => {
    return (
        <div className="mx-auto mt-xl flex flex-col items-center space-y-m">
            <div
                className={styles.LoadingSpinner}
                data-testid="decision-loading"
            >
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>

            <Text className="text-structure-60">
                <FormattedMessage
                    id="_.topup_choice.decision_loading"
                    defaultMessage="Checking your credit profile"
                />
            </Text>
        </div>
    );
};
